<template>
    <div class="root" ref="root">
      <van-notice-bar
        left-icon="volume-o"
        v-if="channelNotice && channelNotice.length > 5"
        :text="channelNotice"
      />
        <div class="page-headernew">
          <img v-if="userInfo.member && userInfo.member.headimgurl" :src="userInfo.member.headimgurl" class="img1">
          <img v-else src="../assets/images/images/indexlogo_03.png" class="img">
          <div class="account-info">
            <div style="display: flex"><div style="text-align: left;flex: 90%;">{{userInfo.username}}</div><div style="width: 10%;color: #ff4949;" @click="logout">退出</div></div>
            <div>当前佣金:{{commission.totalRemain}},待到账佣金:{{commission.totalRecent}},成本扣除:{{commission.cost}}</div>
          </div>
        </div>
        <div class="my-account">
          <div class="title">我的账户</div>
          <div class="columns-list">
            <div @click="showInfo='cardNum'" class="columns-list-item">
              <img src="../assets/images/images/nav1_03.png">
              <div>产品数量</div>
            </div>
            <div @click="showInfo='agentNum'" class="columns-list-item">
              <img src="../assets/images/images/nav2_03.png">
              <div>代理数量</div>
            </div>
            <div @click="showInfo='agentCommissionNum'" class="columns-list-item">
              <img src="../assets/images/images/nav3_03.png">
              <div>有效代理</div>
            </div>
          </div>
          <div class="columns-list">
            <div @click="editPassWord" class="columns-list-item">
              <img src="../assets/images/images/nav4_03.png">
              <div>修改密码</div>
            </div>
            <div @click="handleSubmit" class="columns-list-item">
              <img src="../assets/images/images/nav5_03.png">
              <div>我要提现</div>
            </div>
            <div @click="showInfo='activeNum'" class="columns-list-item">
              <img src="../assets/images/images/nav6_03.png">
              <div>激活率</div>
            </div>
          </div>
        </div>
        <div class="my-account action-list">
          <div class="title">快捷操作</div>
          <van-cell-group>
              <van-cell class="cell" title-class="cell-title" title="新增代理" is-link :to="{name:'agentadd'}"/>
              <van-cell class="cell" title-class="cell-title" title="批量划卡" is-link :to="{name:'dividecard'}"/>
              <van-cell class="cell" title-class="cell-title" title="设置佣金" is-link :to="{name:'setCommission'}"/>
              <van-cell class="cell" title-class="cell-title" title="佣金明细" is-link :to="{name:'rebatelist'}"/>
          </van-cell-group>
        </div>
      <div class="my-account detail">
        <div class="title">账户详情</div>
        <div class="content">
          <template v-if="showInfo=='cardNum'">{{account.cardCount}}</template>
          <template v-if="showInfo=='agentNum'">{{account.agentCount}}</template>
          <template v-if="showInfo=='agentCommissionNum'">{{account.agentCommissionNum}}</template>
          <template v-if="showInfo=='activeNum'">{{account.activeNum}}%</template>
        </div>
      </div>
      <van-divider class="divider">没有更多了</van-divider>
    </div>
</template>
<script>
    export default {
        name: "login",
        data() {
            return {
              userInfo:{},
                mobileVerifyModal: false,
                withdrawMomey: '',
                active: 0,
                length: 5,
                modalShow: false,
                keyboardShow: false,
                loadingCommission: false,
                loadingWithdraw: false,
                finishedWithdraw: false,
                finishedCommission: false,
                commissionList: [],
                withdrawList: [],
                commissionPage: 1,
                withdrawPage: 1,
                account: {
                    cardCount: 0,
                    agentCount: 0,
                  agentCommissionNum:0,
                  activeNum: 0
                },
              showInfo:'',
                dataToday: {
                    orderCount: 0,
                    orderMoney: 0,
                    commission: 0
                },
                commission: {
                    total: 0,
                    withdraw: 0,
                    remain: 0
                },
                channelNotice: '',

            };
        },
      mounted() {
          this.$refs.root.style.minHeight = window.innerHeight+'px'
      },
      created: function () {
            this.getAccount();
            this.getCommission();
            this.getChannelNotice();
            this.checkPendingConfirm();
          this.fetchData('/account/info',{},(res)=>{
            this.userInfo = res.data
          })
        },
        methods: {
            logout(){
                sessionStorage.clear();
                this.$router.push({name:"login"})
            },
          editPassWord(){
            this.$router.push({name:"resetpassword"})
          },
            getAccount() {
                this.fetchData('/account/data', '', (res) => {
                    if (res.code) {
                        this.account = res.data
                    }
                })
            },
            showNextTips() {
                if (this.channelNotice && this.channelNotice.length > 0) {
                    this.$dialog.alert({
                        message: this.channelNotice,
                        title: '通知'
                    })
                }
            },
            getChannelNotice() {
                this.fetchData('/config/getChannelNotice', '', (res) => {
                    if (res.code) {
                        this.channelNotice = res.data
                    }
                })
            },
            getCommission() {
                this.fetchData('/account/commission', '', (res) => {
                    if (res.code) {
                        this.commission = res.data
                    }
                })
            },
            checkPendingConfirm(){
              this.fetchData('/withdraw/pendingConfirm', '', (res) => {
                if (res.code && res.data && res.data.length > 0) {
                  const item = res.data[0]
                  this.$dialog.confirm({
                    title: '待确认收款',
                    message: `您有一笔￥${item.money}的微信提现待确认收款，是否立即确认？`,
                  }).then(() => {
                    this.confirmMerchantTransfer(item)
                  }).catch(() => {})
                }
              })
            },
            confirmMerchantTransfer(data){
              if (!data || !data.package) {
                this.$toast('确认收款参数缺失，请稍后重试或联系客服')
                return
              }
              const doInvoke = () => {
                // eslint-disable-next-line no-undef
                WeixinJSBridge.invoke('requestMerchantTransfer', {
                  mchId: String(data.mchId),
                  appId: String(data.appId),
                  package: data.package,
                }, (res) => {
                  if (res.err_msg === 'requestMerchantTransfer:ok') {
                    this.$toast.success('已提交确认，请等待到账')
                  } else {
                    this.$toast('未完成确认，可稍后再次打开首页确认')
                  }
                })
              }
              // eslint-disable-next-line no-undef
              if (typeof WeixinJSBridge === 'undefined') {
                document.addEventListener('WeixinJSBridgeReady', doInvoke, false)
              } else {
                doInvoke()
              }
            },
            handleSubmit() {
                if (this.commission.remain <= 0) {
                    this.$toast.fail('没有余额')
                    return false;
                }

                this.$router.push({name:'withdraw'})
            },

        }
    };
</script>
<style lang="scss" scoped>
.root{
  background: #fdfeff;
  .divider{
    width: 6.9rem;
    margin: .3rem auto 0;
  }
  .detail{
    margin-top: .3rem!important;
    .content{
      width: 100%;
      height: 1.6rem;
      line-height: 1.6rem;
      font-size: .42rem;
      font-weight: bold;
      text-align: center;
    }
  }
  .action-list{
    margin-top: .3rem!important;
    .cell-title{
      text-align: left;
      font-size: .24rem;
      line-height: 1.2;
    }
    .cell{
      padding-left: 0!important;
    }
  }
  .my-account{
    width: 6.3rem;
    margin: -.6rem auto 0;
    border-radius: .3rem;
    padding: .3rem;
    box-shadow: 0 0 10px #f2f6ff;
    background: #fff;
    .title{
      font-size: .3rem;
      font-weight: bold;
      color: #242424;
    }
    .columns-list{
      display: flex;
      padding: .4rem .4rem 0 .4rem;
      justify-content: space-between;
      .columns-list-item{
        text-align: center;
        min-width: 1.2rem;
        >img{
          width: .6rem;
          height: .6rem;
          margin: 0 auto;
          display: block;
        }
        >div{
          font-size: .24rem;
          color: #242424;
          line-height: .42rem;
          white-space: nowrap;
        }
      }
    }
  }
  .page-headernew{
    padding: .3rem .3rem .9rem .3rem;
    background: #f2f6ff;
    border-bottom-right-radius: .3rem;
    border-bottom-left-radius: .3rem;
    display: flex;
    .img{
      width: .77rem;
      height: .77rem;
      padding: .22rem;
      border-radius: 50%;
      background: #79a3fe;
    }
    .img1{
      width: 1.17rem;
      height: 1.17rem;
      padding: .02rem;
      border-radius: 50%;
      background: #79a3fe;
    }
    .account-info{
      width: 100%;
      margin-left: .2rem;
      padding-top: .1rem;
      line-height:.5rem;
      :first-child{
        font-size: .3rem;
        color: #242424;
      }
      :last-child{
        font-size: .24rem;
        color: #0051fe;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index.vue